
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppButton } from '@/components';
import useIapClone from '@/modules/iap/model/clone';
import { ROUTE_NAME_IAP } from '@/modules/iap/router';

export default defineComponent({
    name: ROUTE_NAME_IAP.CLONE,
    components: { AppFormRow, AppInput, AppSelect, AppButton, AppCard },
    setup() {
        const { v$, model, features, fetch, create } = useIapClone();

        onMounted(() => {
            fetch();
        });

        return { v$, model, features, create };
    }
});
